import { CdkMenuModule } from '@angular/cdk/menu';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { PalantirLabelColors } from '../../../../../shared/pipes/labels/labels.type';
import { PalantirContentComponent } from '../../../../content/content.component';
import type { PalantirIcon } from '../../../../icon/icon.type';
import { PalantirTagComponent } from '../../../../tag/tag.component';
import { PalantirTextComponent } from '../../../../text/text.component';

@Component({
  selector: 'palantir-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PalantirTextComponent,
    PalantirTagComponent,
    PalantirTextComponent,
    CdkMenuModule,
    PalantirContentComponent,
  ],
})
export class PalantirTableTagsComponent {
  @Input({ required: true }) public tags: {
    color: PalantirLabelColors;
    prefix?: PalantirIcon;
    suffix?: PalantirIcon;
    tag: string;
  }[] = [];

  @Input({ required: true }) public labelTranslate!: string;

  @Input() public emptyText: string = '';

  public trackByFn(
    index: number,
    item: { color: PalantirLabelColors; prefix?: PalantirIcon; suffix?: PalantirIcon; tag: string },
  ): string {
    return item.tag + index;
  }
}
